// hooks/useCarWashActions.ts
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../../../../features/auth/axiosConfig";
import { OrderItem, MultiCarItem } from "../../home/components/types";

interface UseCarWashActionsProps {
  multiCar: MultiCarItem[];
  editCarIndex: number | null;
  customerId: string | null;
  calculateTotalPrice: () => number | string;
  addProductToCar: (product: OrderItem, carIndex: number | null) => void;
  setIsModalOpen: (val: boolean) => void;
  clearAllData?: () => void;
}

export const useCarWashActions = ({ multiCar, editCarIndex, customerId, calculateTotalPrice, addProductToCar, setIsModalOpen, clearAllData }: UseCarWashActionsProps) => {
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState<"cash" | "Buy on credit">(() => {
    const saved = localStorage.getItem("carWashPaymentMethod");
    return (saved as "cash" | "Buy on credit") || "cash";
  });

  /** Add product to selected car */
  const handleProductClick = useCallback(
    (product: OrderItem) => {
      if (multiCar.length === 0) {
        toast.warning("Please add a car first.");
        setIsModalOpen(true);
        return;
      }
      addProductToCar(product, editCarIndex);
    },
    [multiCar, editCarIndex, addProductToCar, setIsModalOpen]
  );

  const handlePaymentMethodChange = useCallback((method: "cash" | "Buy on credit") => {
    setPaymentMethod(method);
    // localStorage.setItem("carWashPaymentMethod", method);
  }, []);

  const handleNext = useCallback(async () => {
  if (!multiCar.length || multiCar.every((car) => car.productDetails.length === 0)) {
    toast.warning("Please select at least one product before proceeding.");
    return;
  }

  const updateData = {
    totalOrderPrice: calculateTotalPrice(),
    serviceDetails: multiCar,
    payment: {
      paymentMethod,
    },
  };

  try {
    await api.put(`/app/v1/pos/shopping_cart/${customerId}`, updateData);
    await api.post(`/app/v1/pos/shopping_cart/${customerId}`, updateData);
    navigate(`/v1/car-payment-cash?id=${customerId}`);
  } catch (error) {
    console.error("Error updating car details:", error);
    toast.error("Failed to process order. Please try again.");
  }
}, [multiCar, calculateTotalPrice, customerId, paymentMethod, navigate]);


  return {
    handleProductClick,
    handleNext,
    paymentMethod,
    handlePaymentMethodChange,
  };
};